import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApplicationService } from 'src/app/services/application.service';

@Component({
    selector: 'app-modal-dialog',
    templateUrl: './modal-dialog.component.html',
    styleUrls: ['./modal-dialog.component.scss'],
    standalone: false
})
export class ModalDialogComponent {
  @Output() closeModal = new EventEmitter<boolean>();
  @Output() navigate = new EventEmitter<boolean>();

  @Input() selectModal = '';
  @Input()
  public respDesc: string = '';

  errorMsg: string = 'Oops! Something went wrong.';
  dashboardMessage: string = 'Are you sure you want to go to dashboard?';
  canvasserMessage: string = '';

  errorModal: boolean = false;
  dashboardModal: boolean = false;

    constructor(
      private _applicationService: ApplicationService
    ){
      this._applicationService.cavanvasserMessage$
      .subscribe((canvasserMessage) => {
        this.canvasserMessage = canvasserMessage
      })
    }

  navigateToDashboard(): void {
    this.navigate.emit(true);
  }

  closePopup(): void {
    this.closeModal.emit(true);
  }
  
  modalDisplay = 'block';
}
